import { Button, ButtonGroup, ModalBody, ModalFooter, useToast } from "@chakra-ui/react";
import { Form, Modal } from "components";
import { API } from "config";
import { useProductCategories, useSuppliers } from "hooks";
import { useRef, useState } from "react";
import { useNavigate } from "react-router";

export default function Create({ ...props }){

    const submitRef = useRef()
    const toast = useToast()
    const navigate = useNavigate()
    const [ form, setForm ] = useState({})
    const [ loading, setLoading ] = useState(false)
    const [ errors, setErrors ] = useState(false)

    const suppliers = useSuppliers()
    const categories = useProductCategories()

    const onChange = ({ target }) => {
        const { name, value } = target
        setForm({...form, [name]: value })
    }

    const handleSubmit = async () => {
        setLoading(true)

        try{
            const callback = await API.post('/products', form)

            toast({ title: `O produto ${form.name} foi registrado`, status: 'success' })
            navigate(`/products/${callback.data?.id}`)
        }catch(err){
            setErrors(err?.response?.data?.errors)
            toast({ title: "Não foi possível registrar o produto", description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }
    
    return(
    <Modal title="Adicionar produto" loading={loading} {...props}>
        <ModalBody>
            <Form.Form submitRef={submitRef} onSubmit={handleSubmit}>

                <Form.Text
                    required
                    label="Nome do produto:"
                    name="name"
                    value={form?.name}
                    error={errors?.name}
                    onChange={onChange}
                    size="lg"
                    isDisabled={loading}
                />

                <Form.Select
                    required
                    label="Fornecedor"
                    name="supplier_id"
                    value={form?.supplier_id}
                    options={suppliers.data?.map(item => ({ label: item.name, value: item.id }))}
                    onChange={onChange}
                    isDisabled={loading}
                />

                <Form.Select
                    required
                    label="Categoria principal:"
                    name="category_id"
                    value={form?.category_id}
                    options={categories.data?.map(item => ({ label: item.name, value: item.id }))}
                    onChange={onChange}
                    isDisabled={loading}
                />

                <Form.Select
                    label="Subcategoria:"
                    name="subcategory_id"
                    value={form?.subcategory_id}
                    options={categories.data?.map(item => ({ label: item.name, value: item.id }))}
                    onChange={onChange}
                    isDisabled={loading}
                />

            </Form.Form>
        </ModalBody>
        <ModalFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Button children="Registrar produto" isLoading={loading} onClick={() => submitRef.current.click()} />
                <Button colorScheme="red" children="Cancelar" onClick={props.onClose} />
            </ButtonGroup>
        </ModalFooter>
    </Modal>
    )
}